/**
 * Imágenes del producto (DPS45 · Gestalt Session Ready).
 *
 * Los mockups están en Drive (Producto - DPS45 / mockup) pero NO son
 * públicos, así que todavía no se pueden enlazar. Cuando estén subidos
 * (a Magic Patterns o a Recursos de ImpulTienda), pegar acá la URL pública:
 *
 * HERO_MOCKUP  ← "DPS45 - Principal - Gestalt Session Ready.png"
 * BONUS_COVERS ← "DPS45 - Bono 1..5 - <nombre>.png"
 *
 * Mientras sean null, la landing muestra portadas diseñadas en código con la
 * identidad de los tomos (sin íconos rotos).
 */
export const HERO_MOCKUP: string | null =
  'https://cdn.magicpatterns.com/uploads/93veRkDhGCLqwUPyh783Ln/Photorealistic-product-mockup-warm-life.png'

export const BONUS_COVERS: Record<string, string | null> = {
  '01': 'https://cdn.magicpatterns.com/uploads/99XPrV1cAxzN7q4dZTZkwk/DPS45_-_Bono_1_-_The_Printable_Card_Deck.png',
  '02': 'https://cdn.magicpatterns.com/uploads/v76Ex5Rtye3EYoh3Hp2DnK/DPS45_-_Bono_2_-_See_One_Session,_Start_to_Finish.png',
  '03': 'https://cdn.magicpatterns.com/uploads/eA65etiFrAcZUWDMZQBk1Q/DPS45_-_Bono_3_-_The_7-Day_Adoption_Plan.png',
  '04': 'https://cdn.magicpatterns.com/uploads/kwyR1a1DCfzxRnYYxbhDjJ/DPS45_-_Bono_4_-_The_Therapists_Pre-Session_Routine.png',
  '05': 'https://cdn.magicpatterns.com/uploads/heATHJCZMCVniAFw2eM5BM/DPS45_-_Bono_5_-_Gestalt_in_Short_and_Integrative_Sessions.png',
}

export type Band = 'sage' | 'teal' | 'terra' | 'ochre' | 'ink'

export type InsidePage = {
  /** Captura real de la página (opcional). null = miniatura diseñada. */
  image: string | null
  volume: string
  type: string
  title: string
  band: Band
}

/** Páginas reales de los índices aprobados (títulos tal cual están en los tomos). */
export const INSIDE_PAGES: InsidePage[] = [
  {
    image: null,
    volume: 'Vol. 1 · Here & Now',
    type: 'Framework',
    title: 'The Figure-to-Experiment Map: from what you notice to what you offer',
    band: 'sage',
  },
  {
    image: null,
    volume: 'Vol. 1 · Here & Now',
    type: 'Quick reference',
    title: '“This feels silly”: 12 responses that keep curiosity alive',
    band: 'terra',
  },
  {
    image: null,
    volume: 'Vol. 4 · Chair Work',
    type: 'Framework',
    title: 'The Chair Work Grade Ladder: five rungs, from “about” to “switch”',
    band: 'sage',
  },
  {
    image: null,
    volume: 'Vol. 2 · Contact',
    type: 'Framework',
    title: 'The Contact Interruption Compass: seven interruptions at a glance',
    band: 'sage',
  },
  {
    image: null,
    volume: 'Vol. 4 · Chair Work',
    type: 'Worksheet',
    title: 'WS-16 Polarity Map: what each side says, wants and fears',
    band: 'terra',
  },
  {
    image: null,
    volume: 'Vol. 6 · Group Gestalt',
    type: 'Session formula',
    title: 'The group session formula: 90 and 120-minute versions',
    band: 'teal',
  },
  {
    image: null,
    volume: 'Vol. 4 · Chair Work',
    type: 'Field card',
    title: 'Chair Work Field Card: room diagram, grade ladder, 15 stuck-moment lines',
    band: 'ochre',
  },
]

export const bandBg: Record<Band, string> = {
  sage: 'bg-sage',
  teal: 'bg-teal',
  terra: 'bg-terra',
  ochre: 'bg-ochre',
  ink: 'bg-ink',
}
